import React from "react";
import { ChartIcon, Cube } from "../../Icons";
import { Link } from "react-router-dom";

export default function Navbar({ path = "/dashboard" }) {
  const links = [
    {
      icon: ChartIcon,
      title: "Dashboard",
      link: "/dashboard",
    },
    {
      icon: Cube,
      title: "3D Viewer",
      link: "/3d-viewer",
    },
  ];

  return (
    <div className="flex items-center sm:gap-12 gap-4 pl-4 md:pl-0 ">
      {links.map((it, idx) => {
        const Icon = it.icon;
        return (
          <Link
            key={idx}
            to={it.link}
            className={`flex items-center gap-2.5 border-b-[3px]  py-[14px] sm:px-[5px] px-4 transition-colors duration-300 text-[14px] font-normal ${
              path === it.link
                ? "text-[#E96F0C] border-[#E96F0C]"
                : "text-[#8E98C7] border-transparent "
            }`}
          >
            <Icon color={path === it.link ? "#E96F0C" : "#8E98C7"} />
            <span className="hidden sm:block">{it.title}</span>
          </Link>
        );
      })}
    </div>
  );
}
